var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QRCode qr-canvas",style:({width: _vm.width + 'px',height: _vm.height + 'px'})},[_c('canvas',{attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }